<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">{{ $t('view') }} {{ $tc('denomination' , 2) }}</div>
      <div>
        <a
          class="btn-blue"
          @click.prevent.stop="goToRoute('/master/edit-denomination')"
        >{{ $t('edit') }}</a>
        <router-link
          class="btn-blue"
          to="denominations"
        >{{ $tc('denomination' , 2) }} {{ $tc('list', 2) }}</router-link>
      </div>
    </div>

    <div class="all-details-container">
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $tc('country', 1) }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10">{{ denominations.country_name }}</div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $tc('currency', 1) }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10">{{ denominations.curr_code }}</div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div
                class="col-md-3 col-lg-2 col-xl-2"
              >{{ $tc('denomination' , 2) }} {{ $t('value') }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10">{{ denominations.denomination_value }}</div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $tc('status', 1) }}</div>
              <div
                class="col-md-9 col-lg-10 col-xl-10"
              >{{ denominations.denomination_is_active === 'Y' ? $t('active'):'' }}</div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom" v-if="GetRoleId && GetRoleId === 1 ">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('createdby') }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                <span>{{ denominations.created_by ? denominations.created_by: '' }}</span>
                <!-- <span>{{ $tc('ho', 1) }} {{ $t('manager') }}</span> -->
              </div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom" v-if="GetRoleId && GetRoleId === 1 ">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('createdat') }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                <span
                  class="mr-3"
                >{{ denominations.created_at ? denominations.created_at: '' | dateparse }}</span>
                <!-- <span class="mr-3">06/04/2019</span>
                <span>12:05 AM</span>-->
              </div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom" v-if="GetRoleId && GetRoleId === 1 ">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('modifiedby') }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                <span>{{ denominations.updated_by ? denominations.updated_by: '' }}</span>
                <!-- <span>{{ $tc('ho', 1) }} {{ $t('manager') }}</span> -->
              </div>
            </div>
          </div>

          <div class="col-md-12 py-2" v-if="GetRoleId && GetRoleId === 1 ">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('modifiedat') }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                <span
                  class="mr-3"
                >{{ denominations.updated_at ? denominations.updated_at: '' | dateparse }}</span>
                <!-- <span class="mr-3">06/04/2019</span>
                <span>12:05 AM</span>-->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
 
<script>
import MasterService from "@/services/MasterService";

export default {
  data() {
    return {
      denominations: {
        denomination_id: null,
        denomination_value: null,
        denomination_is_active: "N",
        country_id: null,
        country_name: "",
        curr_id: null,
        curr_code: "",
        created_at: null,
        created_by: null,
        updated_at: null,
        updated_by: null
      }
    };
  },
  beforeMount() {
    const { id } = this.$route.query;
    console.log("object :", id);
    if (id) {
      // pas_id
      this.getDenominationList(id);
    } else {
      this.$router.go(-1);
    }
  },
  mounted() {},
  methods: {
    /* eslint-disable */
    getDenominationList: function(denomination_id) {
      MasterService.GetDenominationById({ denomination_id })
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            let obj = data.Records[0];

            // this.denominations = {
            //   ...data.Records[0]
            // };
            Object.keys(this.denominations).map(x => {
              this.denominations[x] = obj[x] || this.denominations[x];
              if (x === "created_by") {
                this.getViewUsersDetails(obj[x], "created_by", "denominations");
              } else if (x === "updated_by") {
                this.getViewUsersDetails(obj[x], "updated_by", "denominations");
              }
            });
          } else {
            // Show Error Message
            console.log("data.message :", data.message);
          }
        })
        .catch(error => {
          // Catch Error:
          console.log("Catch Error on getDenominationList :", error);
        });
    },
    getViewUsersDetails(user_id, fieldvalue, key) {
      this[key][fieldvalue] = "-";
      if (user_id) {
        MasterService.GetUserInfoById({ user_id })
          .then(response => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this[key][fieldvalue] = data.Records[0].user_name;
            } else {
              // Error Message
              console.log("data.message :", data.message);
            }
          })
          .catch(error => {
            // Catch Error
            console.log("Catch Error on getViewUsersDetails :", error);
          });
      }
    },
    goToRoute: function(path) {
      this.$router.push({
        path: path,
        query: {
          id: this.denominations.denomination_id
        }
      });
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/DenominationsComponents/viewDenomination.vue